import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/action", {
    action: "getFxRate",
    sort: "exchangeDate,currencyCode,desc",
    ...params,
  });
};

export const updateFxRate = async (params) => {
  return await fetchFinance("/action", {
    action: "updateFxRate",
    updated: new Date(),
    ...params,
  });
};

export const addFxRate = async (params) => {
  return await fetchFinance("/action", {
    action: "updateFxRate",
    ...params,
  });
};

export const updateFxRateConfig = async (params) => {
  return await fetchFinance("/action", {
    action: "updateFxRateConfig",
    ...params,
  });
};
